export const neckDisabilityIndexEn = {
  promInstructions:
    "Please choose the option that most closely describes how your neck pain affects your present day situation.",
  questions: [
    {
      scaleStartLabel: "No Pain",
      scaleEndLabel: "Worst Imaginable",
      scaleLabels: [
        "I have no pain at the moment",
        "The pain is very mild at the moment",
        "The pain is moderate at the moment",
        "The pain is fairly severe at the moment",
        "The pain is very severe at the moment",
        "The pain is the worst imaginable at the moment",
      ],
      text: "Can you describe your pain intensity?",
    },
    {
      scaleStartLabel: "Not Affected",
      scaleEndLabel: "Very Affected",
      scaleLabels: [
        "I can look after myself normally without causing extra pain",
        "I can look after myself normally, but it causes extra pain",
        "It is painful to look after myself, and I am slow and careful",
        "I need some help but manage most of my personal care",
        "I need help every day in most aspects of self-care",
        "I do not get dressed. I wash with difficulty and stay in bed",
      ],
      text: "Can you describe how your neck symptoms affect your personal care?",
    },
    {
      scaleStartLabel: "Not Affected",
      scaleEndLabel: "Very Affected",
      scaleLabels: [
        "I can lift heavy weights without causing extra pain",
        "I can lift heavy weights, but it gives me extra pain",
        "Pain prevents me from lifting heavy weights off the floor, but I can manage if items are conveniently positioned, ie. on a table",
        "Pain prevents me from lifting heavy weights, but I can manage light weights if they are conveniently positioned",
        "I can lift only light weights",
        "I cannot lift or carry anything at all",
      ],
      text: "Can you describe how your neck symptoms affect your ability to lift weights?",
    },
    {
      scaleStartLabel: "Not Affected",
      scaleEndLabel: "Very Affected",
      scaleLabels: [
        "I can do as much work as I want",
        "I can only do my usual work, but no more",
        "I can do most of my usual work, but no more",
        "I can't do my usual work",
        "I can hardly do any work at all",
        "I can't do any work at all",
      ],
      text: "Can you describe how your neck symptoms affect your ability to work?",
    },
    {
      scaleStartLabel: "No Headaches",
      scaleEndLabel: "All the Time",
      scaleLabels: [
        "I have no headaches at all",
        "I have slight headaches that come infrequently",
        "I have moderate headaches that come infrequently",
        "I have moderate headaches that come frequently",
        "I have severe headaches that come frequently",
        "I have headaches almost all the time",
      ],
      text: "Do your neck symptoms result in headaches?",
    },
    {
      scaleStartLabel: "Not Affected",
      scaleEndLabel: "Very Affected",
      scaleLabels: [
        "I can concentrate fully without any difficulty",
        "I can concentrate fully with slight difficulty",
        "I have a fair degree of difficulty concentrating",
        "I have a lot of difficulty concentrating",
        "I have a great deal of difficulty concentrating",
        "I can't concentrate at all",
      ],
      text: "Can you describe how your neck symptoms affect your ability to concentrate?",
    },
    {
      scaleStartLabel: "Not Affected",
      scaleEndLabel: "Very Affected",
      scaleLabels: [
        "I have no trouble sleeping",
        "My sleep is slightly disturbed for less than 1 hour",
        "My sleep is mildly disturbed for up to 1-2 hours",
        "My sleep is moderately disturbed for up to 2-3 hours",
        "My sleep is greatly disturbed for up to 3-5 hours",
        "My sleep is completely disturbed for up to 5-7 hours",
      ],
      text: "Can you describe how your neck symptoms affect your ability to sleep?",
    },
    {
      scaleStartLabel: "Not Affected",
      scaleEndLabel: "Very Affected",
      scaleLabels: [
        "I can drive my car without neck pain",
        "I can drive as long as I want with slight neck pain",
        "I can drive as long as I want with moderate neck pain",
        "I can't drive as long as I want because of moderate neck pain",
        "I can hardly drive at all because of severe neck pain",
        "I can't drive my car at all because of neck pain",
      ],
      text: "Can you describe how your neck symptoms affect your ability to drive?",
    },
    {
      scaleStartLabel: "Not Affected",
      scaleEndLabel: "Very Affected",
      scaleLabels: [
        "I can read as much as I want with no neck pain",
        "I can read as much as I want with slight neck pain",
        "I can read as much as I want with moderate neck pain",
        "I can't read as much as I want because of moderate neck pain",
        "I can't read as much as I want because of severe neck pain",
        "I can't read at all",
      ],
      text: "Can you describe how your neck symptoms affect your ability to read?",
    },
    {
      scaleStartLabel: "Not Affected",
      scaleEndLabel: "Very Affected",
      scaleLabels: [
        "I have no neck pain during all recreational activities",
        "I have some neck pain with all recreational activities",
        "I have some neck pain with a few recreational activities",
        "I have neck pain with most recreational activities",
        "I can hardly do recreational activities due to neck pain",
        "I can't do any recreational activities due to neck pain",
      ],
      text: "Can you describe how your neck symptoms affect your recreational activities?",
    },
  ],
};
